export const zenmentumDesc =
  "ZenMentum is a productivity app that records activities that you input in order to keep track of how productive you're being on a week to week basis.";

export const bandBountyDesc =
  'Band-Bounty is a fictitious website that integrates web3 technology with a crowd-funding platform allowing fans to organise shows in their area with artists of their choice.';

export const sightReaderDesc =
  'Sight-Reader is an app that helps musicians improve their music notation sight-reading skills in the form of a game and a race against the clock. (To play - just register fake details, no email verification necessary)';

export const translatorDesc =
  'Nordic Translator is a simple app that connects to the Google Translate API and converts any english prompt given at the top of the page into the different Nordic countries native languages. ';

export const geoExpDesc =
  "Geo-Explorer is a web app that upon a user's request, communicates with the public REST Countries API to display information about chosen countries and returns specific information about a user's chosen country.";

export const noteWarr =
  'Note-Warriors is a mock site representing a music learning platform. I recently finished a UX/UI design course so I wanted to put some of the theory I learned into action.';
